export enum QueryParamsStrings {
  SELECTED_MODULE = 'selected_module',
  SELECTED_ROUTE = 'selected_route',
  PENSUM_ID = 'pensum_id',
  PENSUM_NAME = 'pensum_name',
  FROM = 'from',
}
